<div class="container">
	@for (t of templates(); track t.name) {
		<lvr-document-item [document]="t" (open)="openTemplate(t.name)"></lvr-document-item>
	}
</div>
